import cx from 'classnames';
import { icon_check_off, icon_check_on } from 'components/base/images';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import { userCustomOption } from 'lib/mapper';
import { materialImgList } from 'lib/teeth/teethMaterialMapper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { color } from 'styles/utils';

interface MaterialListProps {
  matchMaterailListDef: any;
  // matchMaterailListCM: any;
  matchingMaterialList: any;
  indication: {
    value: {
      // id: number;
      id: string;
      seq: string;
      color: string;
    };
    onChange: (e: any) => void;
    setValue: (value: object) => void;
  };
  material: { value: string; onChange: (e: any) => void; setValue: (value: string) => void };
  isMultidie: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  onChooseMaterial: (seq: string, alias: string) => void;
}

function MaterialList({
  matchMaterailListDef,
  // matchMaterailListCM,
  matchingMaterialList,
  indication,
  material,
  isMultidie,
  onChooseMaterial,
}: MaterialListProps) {
  const { t } = useTranslation();
  const materialList = isMultidie.value === 0 ? matchingMaterialList : matchMaterailListDef;

  return (
    <StyledMaterialList>
      <div className="materialList__title">
        <CustomText fontSize={20} fontWeight={500}>
          <T>GLOBAL_MATERIAL</T>
        </CustomText>
      </div>
      <div className="materialList__container">
        {!!materialList?.length &&
          materialList.map((partItem: any, partIdx: number) => {
            const isUserCustomOption = partItem.alias.split('_')[0] == userCustomOption.material;
            const isEqualMaterial = material.value === partItem.seq;
            const materialImg = materialImgList.find(i => i.id === partItem.seq);

            const partListLastIdx = materialList.length;
            const divideLastIdx = partListLastIdx % 2;
            const noBorderBottomIdxList = Array.from({
              length: 2,
            }).map((_, idx) => partListLastIdx - idx);
            const currentIdx = partIdx + 1;
            let isNoBorderBottom = null;
            if (divideLastIdx === 0 && noBorderBottomIdxList.includes(currentIdx)) {
              isNoBorderBottom = true;
            } else if (noBorderBottomIdxList.slice(0, divideLastIdx).includes(currentIdx)) {
              isNoBorderBottom = true;
            }
            return (
              <button
                className={cx('materialList__item', { on: isEqualMaterial })}
                onClick={() => {
                  onChooseMaterial(partItem.seq, partItem.alias);
                }}
                key={partIdx}
              >
                <div className="materialList__check_box">
                  <img src={isEqualMaterial ? icon_check_on : icon_check_off} />
                </div>
                <div className="materialList__icon_box">
                  {materialImg?.src && <img src={materialImg.src} alt="material" />}
                </div>
                <div className="materialList__text_box">
                  <CustomText
                    fontSize={14}
                    fontColor={isEqualMaterial ? '#00A6E2' : '#666'}
                    fontWeight={400}
                  >
                    {isUserCustomOption ? partItem.name : t(`MATERIAL_${partItem.alias}`)}
                  </CustomText>
                </div>
              </button>
            );
          })}
      </div>
    </StyledMaterialList>
  );
}

const StyledMaterialList = styled.div`
  margin-top: 14px;
  height: calc(100% - 14px);
  display: flex;
  flex-direction: column;
  .materialList__title {
    margin-bottom: 20px;
  }
  .materialList__container {
    height: 100%;
    overflow: auto;
    .materialList__item {
      border: 1px solid #e1e1e7;
      width: 250px;
      height: 50px;
      display: flex;
      padding: 0 12px;
      align-items: center;
      &:not(:last-child) {
        border-bottom: 0px;
      }
      &.on {
        border: 2px solid #00a6e2;
      }
      .materialList__check_box {
      }
      .materialList__icon_box {
        display: flex;
        width: 48px;
        height: 100%;
        margin: 10px;
        align-items: flex-end;
        justify-content: center;
      }
      .materialList__text_box {
      }
    }
  }
`;

const StyledCheckBox = styled.div`
  width: 18px;
  height: 18px;
  border: 1px solid ${color.gray_week};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default MaterialList;
